module.exports = __webpack_public_path__ + "img/S_and_P.31e09d3b.png";